// TeamPayroll.js
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import AccordionSection from "../My Payroll/AccordionComponent";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import moment from "moment";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

const TeamPayroll = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(updateNavbarHeading("Team Payroll"));
  }, []);

  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [datapayroll, setDataPayroll] = useState([]);
  const [listEmployee, setListEmployee] = useState([]);
  const [listMonth, setListMonth] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [dataEarning, setDataEarning] = useState([]);
  const [dataDeduction, setDataDeduction] = useState([]);
  const [grossPayable, setGrossPayable] = useState([]);
  const [totalDeductionData, setTotalDeductionData] = useState([]);
  const [netPayable, setNetPayable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
const [apiStatus,setApiStatus] = useState('')
  const fetchTeamPayroll = async (month, emp) => {
    setApiStatus(undefined)
    try {
      const response = await GetServiceCaller(
        `${API_URL}my/team/payroll?P_MonthID=${month || 0}&P_EmployeeID=${emp || 0
        }`
      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const payrolldata = response?.data?.payrolldata;
        setDataPayroll(payrolldata);
        const EmployeeList = response?.data?.employee.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setListEmployee(EmployeeList);
        const MonthList = Object.entries(response?.data?.months)
          .map(([key, value]) => ({
            value: key,
            label: value,
          }))
          .sort((a, b) => Number(b.value) - Number(a.value));
        setListMonth(MonthList);
        const data = response?.data?.payrolldata?.employeeDetails;
        setEmployeeData(data);
        const dataAttendance = response?.data?.payrolldata?.attendanceDetails;
        setAttendanceData(dataAttendance);
        const earningsData = response?.data?.payrolldata?.earnings;
        setDataEarning(earningsData);
        const deductionData = response?.data?.payrolldata?.deductions;
        setDataDeduction(deductionData);
        const grossData = response?.data?.payrolldata?.grosspayable;
        setGrossPayable(grossData);
        const totalDeduction = response?.data?.payrolldata?.totaldeduction;
        setTotalDeductionData(totalDeduction);
        const netPayableData = response?.data?.payrolldata?.netPayable;
        setNetPayable(netPayableData);
      } else {
        console.error(
          "Failed to fetch payroll data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching payroll data", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      fetchTeamPayroll([]);
      setLoading(false);
    }, 2000);
  }, []);
  const validationSchema = Yup.object().shape({
    selectedMonth: Yup.number().nullable().required("Month is required"),
    selectedEmp: Yup.number().nullable().required("Employee is required"),
  });


  const handleSelectChange = (option, field) => {
    if (field === "selectedMonth") {
      setSelectedMonth(option?.value);
    } else if (field === "selectedEmp") {
      setSelectedEmp(option?.value);
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: null,
    }));
  };

  const handleGetDataClick = async () => {
    try {
      await validationSchema.validate(
        { selectedMonth, selectedEmp },
        { abortEarly: false }
      );

      setErrors({});
      fetchTeamPayroll(selectedMonth, selectedEmp);
    } catch (validationErrors) {
      const formErrors = {};
      validationErrors?.inner?.forEach((error) => {
        formErrors[error.path] = error.message;
      });
      setErrors(formErrors);
    }
  };

  const handleTeamPaySlip = () => {
    navigate("/user/pay-slip", { state: { selectedMonth, selectedEmp } });
  };
  // Render function for employee details
  const renderEmployeeDetails = (item) => (
    <div key={item.id}>
      <h6 style={{ fontSize: "14px" }}>
        <b>Designation</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.Designation}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Joining Date</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{moment(item.JoiningDate).format("DD-MMM-YYYY")}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Date Of Birth</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{moment(item.DateOfBirth).format("DD-MMM-YYYY")}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>PF No</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.PF}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Emp Code</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.EmpCode}</h6>
    </div>
  );

  // Render function for attendance details
  const renderAttendanceDetails = (item) => (
    <div key={item.id}>
      <h6 style={{ fontSize: "14px" }}>
        <b>Working Days</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.WorkingDays}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Present Days</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.PresentDays}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Absent Days</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.AbsentDays}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Leave Taken</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.LeaveTaken}</h6>
      <hr />
      <h6 style={{ fontSize: "14px" }}>
        <b>Leave Balance</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.LeaveBalance}</h6>
    </div>
  );

  // Render function for earnings
  const renderEarnings = (item) => (
    <div key={item.id}>
      <h6 style={{ fontSize: "14px" }}>
        <b>{item.Payroll}</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.Amount}</h6>
      <hr />
    </div>
  );

  // Render function for deductions
  const renderDeductions = (item) => (
    <div key={item.id}>
      <h6 style={{ fontSize: "14px" }}>
        <b>{item.Payroll}</b>
      </h6>
      <h6 style={{ fontSize: "14px" }}>{item.Amount}</h6>
      <hr />
    </div>
  );
  const handleResetClick = () => {
    // Reset both select inputs to null/undefined
    handleSelectChange(null, "selectedMonth");
    handleSelectChange(null, "selectedEmp");
    setErrors({});
    setDataPayroll([])


  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <div className="d-flex align-items-center">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label htmlFor="Code" className="form-label">
                        Month
                      </label>
                      <Select
                        options={listMonth}
                        value={listMonth?.find(item => item.value == selectedMonth) || null}
                        name="selectedMonth"
                        onChange={(option) =>
                          handleSelectChange(option, "selectedMonth")
                        }
                      />
                      {errors?.selectedMonth && (
                        <div className="text-danger">
                          {errors?.selectedMonth}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="mb-3">
                      <label htmlFor="Code" className="form-label">
                        Employee
                      </label>
                      <Select
                        options={listEmployee}
                        value={listEmployee?.find(item => item.value == selectedEmp) || null}
                        name="selectedEmp"
                        onChange={(option) =>
                          handleSelectChange(option, "selectedEmp")
                        }
                      />
                      {errors?.selectedEmp && (
                        <div className="text-danger">{errors?.selectedEmp}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="row">
                  <div className="d-flex gap-1 justify-content-end">
                    <div style={{ marginTop: "20px" }}>
                      <button className="custom-btn" onClick={handleResetClick}>
                        Reset
                      </button>
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      <button
                        className="custom-btn"
                        onClick={handleGetDataClick}
                      >
                        Get Data
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div className="table-responsive">
              <Table
                bordered
                style={{
                  width: "100%",
                  tableLayout: "auto",
                  fontSize: "12px",
                  margin: "0",
                  padding: "0",
                }}
              >
                <thead
                  id="thcolor"
                  className="text-center"
                  style={{ fontSize: "12px" }}
                >
                  <tr>
                    <th scope="col" style={{ width: "15%", padding: "4px" }}>
                      Employee Details
                    </th>
                    <th scope="col" style={{ width: "15%", padding: "4px" }}>
                      Attendance Details
                    </th>
                    <th scope="col" style={{ width: "12%", padding: "4px" }}>
                      Earnings
                    </th>
                    <th scope="col" style={{ width: "10%", padding: "4px" }}>
                      Others
                    </th>
                    <th scope="col" style={{ width: "10%", padding: "4px" }}>
                      Gross Payable
                    </th>
                    <th scope="col" style={{ width: "12%", padding: "4px" }}>
                      Deductions
                    </th>
                    <th scope="col" style={{ width: "10%", padding: "4px" }}>
                      Total Deductions
                    </th>
                    <th scope="col" style={{ width: "10%", padding: "4px" }}>
                      Net Payable
                    </th>
                    <th scope="col" style={{ width: "6%", padding: "4px" }}>
                      Pay Slip
                    </th>
                  </tr>
                </thead>
                {apiStatus== undefined ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan="9"
                        className="text-center"
                        style={{ padding: "4px" }}
                      >
                        <FaSpinner class="spinner" />
                      </td>
                    </tr>
                  </tbody>
                ) : datapayroll.length === 0 ? (
                  <tbody>
                    <tr>
                      <td
                        colSpan="9"
                        className="text-center"
                        style={{ padding: "4px" }}
                      >
                        No Record Found
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td style={{ padding: "4px", overflow: "hidden" }}>
                        <AccordionSection
                          title={
                            (employeeData && employeeData[0]?.Employee) ||
                            "Employee Details"
                          }
                          data={employeeData}
                          renderContent={renderEmployeeDetails}
                          accordionId="one"
                        />
                      </td>
                      <td style={{ padding: "4px", overflow: "hidden" }}>
                        <AccordionSection
                          title="Attendance Details"
                          data={attendanceData}
                          renderContent={renderAttendanceDetails}
                          accordionId="two"
                        />
                      </td>
                      <td style={{ padding: "4px", overflow: "hidden" }}>
                        <AccordionSection
                          title="Earnings"
                          data={dataEarning}
                          renderContent={renderEarnings}
                          accordionId="three"
                        />
                      </td>
                      <td style={{ padding: "4px", overflow: "hidden" }}>
                        <AccordionSection
                          title="Others"
                          data={[]}
                          renderContent={() => <div>No content</div>}
                          accordionId="four"
                        />
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "4px", overflow: "hidden" }}
                      >
                        {grossPayable && grossPayable[0]?.Amount}
                      </td>
                      <td style={{ padding: "4px", overflow: "hidden" }}>
                        <AccordionSection
                          title="Deductions"
                          data={dataDeduction}
                          renderContent={renderDeductions}
                          accordionId="five"
                        />
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "4px", overflow: "hidden" }}
                      >
                        {totalDeductionData}
                      </td>
                      <td
                        className="text-end"
                        style={{ padding: "4px", overflow: "hidden" }}
                      >
                        {netPayable && netPayable[0]?.Amount}
                      </td>
                      <td
                        className="text-center"
                        style={{ padding: "4px", overflow: "hidden" }}
                      >
                        <button
                          className="custom-btn-sm"
                          onClick={handleTeamPaySlip}
                          style={{
                            padding: "2px 4px",
                            fontSize: "12px",
                          }}
                        >
                          Pay Slip
                        </button>
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            </div>
        </div>
      </div>
    </>
  );
};

export default TeamPayroll;
